/**
 * Trust Marquee Section — Seamless marquee with dynamic cloning
 */
(function () {
  function initTrustMarquee(container) {
    var root = container || document;
    var marquee = root.querySelector('.oddit-section-trust-marquee');
    if (!marquee) return;

    var track = marquee.querySelector('.oddit-section-trust-marquee__track');
    var originalSet = track.querySelector('[data-marquee-set]');
    if (!track || !originalSet) return;

    var speed = 50; // pixels per second
    var animationId = null;
    var paused = false;
    var position = 0;
    var setWidth = 0;

    function setup() {
      // Remove previous clones
      var clones = track.querySelectorAll('[data-marquee-clone]');
      for (var i = 0; i < clones.length; i++) {
        track.removeChild(clones[i]);
      }

      // Measure one set (including the track gap between sets)
      var setRect = originalSet.getBoundingClientRect();
      var trackGap = parseFloat(getComputedStyle(track).gap) || 16;
      setWidth = setRect.width + trackGap;

      if (setWidth <= 0) return;

      // Clone enough sets to fill the viewport + one extra
      var viewportWidth = marquee.offsetWidth;
      var clonesNeeded = Math.ceil(viewportWidth / setWidth) + 1;

      for (var j = 0; j < clonesNeeded; j++) {
        var clone = originalSet.cloneNode(true);
        clone.setAttribute('data-marquee-clone', '');
        clone.removeAttribute('data-marquee-set');
        var items = clone.querySelectorAll('[id]');
        for (var k = 0; k < items.length; k++) {
          items[k].removeAttribute('id');
        }
        track.appendChild(clone);
      }

      // Reset position
      position = 0;
      track.style.transform = 'translateX(0px)';
    }

    var lastTimestamp = null;

    function animate(timestamp) {
      if (paused) {
        lastTimestamp = null;
        animationId = requestAnimationFrame(animate);
        return;
      }

      if (lastTimestamp === null) {
        lastTimestamp = timestamp;
      }

      var delta = (timestamp - lastTimestamp) / 1000;
      lastTimestamp = timestamp;

      position -= speed * delta;

      // When we've scrolled past one full set, loop back
      if (Math.abs(position) >= setWidth) {
        position += setWidth;
      }

      track.style.transform = 'translateX(' + position + 'px)';
      animationId = requestAnimationFrame(animate);
    }

    function pause() {
      paused = true;
    }

    function play() {
      paused = false;
    }

    // Pause marquee on hover for accessibility
    marquee.addEventListener('mouseenter', pause);
    marquee.addEventListener('mouseleave', play);

    // Pause on focus within for keyboard users
    marquee.addEventListener('focusin', pause);
    marquee.addEventListener('focusout', play);

    // Respect reduced motion preference
    var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    function handleMotionPreference(e) {
      if (e.matches) {
        pause();
      } else {
        play();
      }
    }
    motionQuery.addEventListener('change', handleMotionPreference);
    handleMotionPreference(motionQuery);

    // Recalculate on resize
    var resizeTimer;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setup, 200);
    }
    window.addEventListener('resize', onResize);

    // Initialize
    setup();
    animationId = requestAnimationFrame(animate);

    // Store cleanup function on the marquee element
    marquee._odditCleanup = function () {
      marquee.removeEventListener('mouseenter', pause);
      marquee.removeEventListener('mouseleave', play);
      marquee.removeEventListener('focusin', pause);
      marquee.removeEventListener('focusout', play);
      motionQuery.removeEventListener('change', handleMotionPreference);
      window.removeEventListener('resize', onResize);
      if (animationId) cancelAnimationFrame(animationId);
    };
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initTrustMarquee(document);
    });
  } else {
    initTrustMarquee(document);
  }

  // Theme editor: re-initialise on section load
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.oddit-section-trust-marquee')) {
      initTrustMarquee(event.target);
    }
  });

  // Theme editor: clean up on section unload
  document.addEventListener('shopify:section:unload', function (event) {
    var marquee = event.target.querySelector('.oddit-section-trust-marquee');
    if (marquee && typeof marquee._odditCleanup === 'function') {
      marquee._odditCleanup();
    }
  });
})();
